import React from 'react';

import { Helpers } from './core/src/helpers';
import CLPContainer from './category-landing-page';
import MainContainer from './main/components/main-container';
import ErrorRedirect from './main/components/error-redirect';
import PDPContainer from './pdp/components/pdp-container';
import MLPContainer from './mlp';
import MDPContainer from './mdp';
import HomeContainer from './home';
import MMDContainer from './pdp/components/mmd';
import Elicit from './shared/components/elicit';
import BlogListContainer from './blog/components/blog-list-container';
import BlogContainer from './blog/components/blog-container';
import DLPContainer from './dlp';
import VWAContainer from './vwa';
import CompareView from './compare/components/compare-view';
import ReorderContainer from './reorder/components/reorder-container';
import { withHeaderFooter } from './page/components/header-footer';

const { memoize } = Helpers;

/**
 * Optimization HOC, for some reason with SSR on initial load the location and match update several times
 * @param  {[type]} WrappedComponent [description]
 * @param  {[type]} resetScroll      [Option to reset scroll and rout change]
 * @return {[type]}                  [description]
 */
function shouldRouteRerender(WrappedComponent, resetScroll) {
  return class extends React.Component {

    componentDidMount() {
      if (resetScroll) {
        window.scrollTo(0, 0);
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      let { location: nextLocation = {}, match: nextMatch = {} } = nextProps;
      let { location = {}, match = {} } = this.props;

      //only update when the URL changes
      return `${location.pathnam}${location.search}${location.hash}` !== `${nextLocation.pathnam}${nextLocation.search}${nextLocation.hash}`
        || match.url !== nextMatch.url;
    }

    componentDidUpdate(prevProps) {
      const { match } = this.props;
      const { match: prevMatch } = prevProps;

      //for now just reset if the slug changes
      if (
        resetScroll && match.url !== prevMatch.url
      ) {
        window.scrollTo(0, 0);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}


export default memoize((basename = process.env.BASENAME, pathOnly = false) => {
  basename = basename || process.env.BASENAME;
  const baseNamePattern = `/:basename(${basename.replace(/^\//, '')}|app)`;
  let routes = [
    {
      component: Elicit,
      path: `${baseNamePattern}/content/elicit`,
      exact: true,
      resetScroll: true,
    },
    {
      ...VWAContainer,
      path: `${baseNamePattern}/:dir(plp|filters)/:slug/:filters?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...DLPContainer,
      path: `${baseNamePattern}/:dir(dlp)/:slug`,
      exact: true,
      resetScroll: true,
    },
    {
      ...CLPContainer,
      path: `${baseNamePattern}/:dir(cat)/:slug`,
      exact: true,
      resetScroll: true,
    },
    {
      ...PDPContainer,
      path: `${baseNamePattern}/:dir(pdp)/:slug/:filters?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...MLPContainer,
      path: `${baseNamePattern}/:dir(mlp)/:slug/:slugTwo?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...MDPContainer,
      path: `${baseNamePattern}/:dir(mdp)/:slug`,
      exact: true,
      resetScroll: true,
    },
    {
      ...MMDContainer,
      path: `${baseNamePattern}/:dir(mmd)/:sku?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...BlogListContainer,
      path: `${baseNamePattern}/:dir(tech-takes)/article-filters/:filters?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...BlogListContainer,
      path: `${baseNamePattern}/:dir(tech-takes)`,
      exact: true,
      resetScroll: true,
    },
    {
      ...BlogContainer,
      path: `${baseNamePattern}/:dir(tech-takes)/:slug/:filters?`,
      exact: true,
      resetScroll: true,
    },
    {
      ...ReorderContainer,
      path: `${baseNamePattern}/reorder`,
      exact: false,
      resetScroll: true,
    },
    {
      ...MainContainer,
      path: `${baseNamePattern}/:dir(slp)/:slug/:filters?`,
      exact: true,
    },
    {
      component: CompareView,
      path: `${baseNamePattern}/compare`,
      exact: true,
      resetScroll: true,
    },
    {
      ...HomeContainer,
      path: `${baseNamePattern}/v2`,
      exact: true,
      resetScroll: true,
    },
    {
      component: ErrorRedirect,
    },
  ];

  if (pathOnly) {
    return routes.map(({ path, exact }) => {
      return { path, exact };
    });
  }

  //TEMP: Fix issue with multiple re-renders because of location change on inital load for SSR
  return routes.map((r) => {
    //TODO: remove withHeaderFooter once all routes have been migrated to use the Page component
    r.component = shouldRouteRerender(withHeaderFooter(r.component), r.resetScroll);
    return r;
  });
});
